import { render, staticRenderFns } from "./vacancy-contacts.vue?vue&type=template&id=20ffc3ce"
import script from "./vacancy-contacts.vue?vue&type=script&lang=js"
export * from "./vacancy-contacts.vue?vue&type=script&lang=js"
import style0 from "./vacancy-contacts.vue?vue&type=style&index=0&id=20ffc3ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports